// IntentionBadge — Header pill showing today's trading intention
import React, { useState, useRef, useEffect } from 'react';
import { useMind } from '../../../context/MindContext';
import { INTENTION_OPTIONS } from '../../../config/mindConstants';
import { FaCrosshairs } from 'react-icons/fa';

export default function IntentionBadge() {
  const { dailyState, isCheckedIn, submitDailyCheck } = useMind();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  if (!isCheckedIn) return null;

  const intention = dailyState?.intention || 'Not set';
  // Show short label (before the em dash)
  const shortLabel = intention.split('—')[0].trim();

  const handleSelect = (newIntention) => {
    submitDailyCheck({
      mood: dailyState?.mood || 3,
      focus: dailyState?.focus || 3,
      stress: dailyState?.stress || 3,
      sleep: dailyState?.sleep || 3,
      intention: newIntention,
    });
    setOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-medium bg-blue-500/20 text-blue-200 ring-1 ring-blue-400/30 hover:bg-blue-500/30 transition-colors"
        title={`Intention: ${intention}`}
      >
        <FaCrosshairs className="text-[9px]" />
        <span className="max-w-[80px] truncate">{shortLabel}</span>
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 w-56 bg-white rounded-lg shadow-xl border border-gray-200 py-1 z-50">
          {INTENTION_OPTIONS.map(opt => (
            <button
              key={opt}
              onClick={() => handleSelect(opt)}
              className={`w-full text-left px-3 py-2 text-[11px] hover:bg-blue-50 transition-colors ${
                intention === opt ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700'
              }`}
            >
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
